import { render, staticRenderFns } from "./RunData.vue?vue&type=template&id=bf56a2d2&"
import script from "./RunData.vue?vue&type=script&lang=ts&"
export * from "./RunData.vue?vue&type=script&lang=ts&"
import style0 from "./RunData.vue?vue&type=style&index=0&id=bf56a2d2&prod&lang=scss&module=true&"
import style1 from "./RunData.vue?vue&type=style&index=1&id=bf56a2d2&prod&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports